import { BenefitUse } from '@witkac/kartamiejska-shared';
import { BenefitUseResource, benefitUseResource } from '@witkac/kartamiejska-resources';

import { EntityModule } from './entity.module';

/**
 * Moduł używania usługi
 * @export
 * @class BenefitUsage
 */
export class BenefitUseModule extends EntityModule<BenefitUse, BenefitUseResource> {
  /**
   * Czy ma być używany namespace
   *
   * @type {boolean}
   */
  public namespaced: boolean = true;

  constructor() {
    super(benefitUseResource);
    this.actions = {
      ...this.actions,
      /**
       * Dodaje użycie usługi
       *
       * @param context context
       * @param data dane do wysłania do API
       */
      add: async (context: any, data: any): Promise<void> => {
        await benefitUseResource.add({ benefitUse: data });
        context.commit('add', data);
      }
    };
  }
}

export default new BenefitUseModule();
